import { config } from '@root/src/javascripts/config'

function updateState(newState) {
  window.localStorage.setItem('dextra-mfv', JSON.stringify(newState))
}

function getState() {
  try {
    return JSON.parse(window.localStorage.getItem('dextra-mfv')) || {}
  } catch (e) {
    return {}
  }
}

function getCurrentVersion({ version }) {
  return version || 0
}

export default function migrateState() {
  const state = getState()
  const currentVersion = config.stateVersion

  if (getCurrentVersion(state) < currentVersion) {
    updateState({ version: currentVersion })
  }
}
